<script setup lang="ts">
import {
  find,
  merge,
  set,
  transform,
} from 'lodash-es';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import type { ITreeItem } from '@components/tree/VTree/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VTree from '@components/tree/VTree/VTree.vue';
import { ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT_ROUTE_NAME } from '@modules/general-settings/submodules/table-columns-settings/submodules/edit/constants';
import { prepareTranslationsList } from '@modules/translate-manager/pages/TranslateManagerPage/composables/utils';

import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS,
  TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS,
} from '../../constants';
import { useTablesTreeListQuery } from '../../queries';

const router = useRouter();

const { data, isLoading } = useTablesTreeListQuery();

const treeList = computed<ITreeItem[]>(() => prepareTranslationsList(
  transform(data.value?.list ?? [], (acc, val) => merge(acc, set({}, val.locale_key, String(val.id))), {}),
));

function goToEditTableColumns(key?: string): void {
  const id = find(data.value?.list, { locale_key: key })?.id;

  if (id) {
    void router.push({ name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT_ROUTE_NAME, params: { id, localeKey: key } });
  }
}
</script>

<template>
  <VCard v-data-qa-auto-id="'AdminGeneralSettingsTablesTreePage'" type="default">
    <VLoader :loading="isLoading">
      <div>
        <label
          class="mb-2 block text-muted-color"
        >
          {{ $getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS, 'TABLES') }}
        </label>
        <VTree :items="treeList">
          <template #parentNode="{ node }">
            {{ node.label }}
          </template>
          <template #leafNode="{ node }">
            <div class="flex items-center gap-2">
              <VIconButton
                v-if="$hasPermission([
                  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.EDIT,
                  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW_VERSIONS,
                ])"
                icon="pi-file-edit"
                @click="goToEditTableColumns(node.key)"
              />
              <div>
                {{ node.label }}
              </div>
            </div>
          </template>
        </VTree>
      </div>
    </VLoader>
  </VCard>
</template>
